import React from 'react';
import { Section } from './Section';
const STATS = [{
  value: '17 años',
  label: 'de experiencia en tecnología'
}, {
  value: '+8.500',
  label: 'equipos Apple vendidos'
}, {
  value: 'Miles',
  label: 'de usuarios ayudados'
}];
export function AboutAuthor() {
  return <Section className="bg-ink-900/60" innerClassName="max-w-5xl" data-id="element-17" data-mp="1t0ocxawuy9hz">
      <div className="grid items-center gap-10 lg:grid-cols-2" data-id="element-18" data-mp="1o0a8s3ydnjp8">
        <img src="https://cdn.magicpatterns.com/uploads/8Vu6HJx32p33t8e462HhiY/ChatGPT_Image_27_jul_2026,_05_53_28_p.m..png" alt="Marcio Gómez sosteniendo la guía Diccionario Apple frente al logo de Apple" className="w-full rounded-3xl border border-white/10 object-cover" data-id="element-19" data-mp="109edgwupq6d8" />

        <div data-id="element-20" data-mp="159itymvmf13g">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-21" data-mp="158r9o87h4psh">
            Quién soy
          </p>
          <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-22" data-mp="2kog9wgw3btyr">
            Marcio Gómez, especialista en el ecosistema Apple
          </h2>

          <p className="mt-6 text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-23" data-mp="2wiyvcvxvpcdr">
            Marcio Gómez es especialista en el ecosistema Apple, con 17 años de
            experiencia en tecnología y más de 8.500 equipos Apple vendidos.
            Desde hace años ayuda a miles de usuarios a sacar el máximo provecho
            de su iPhone. Todo ese conocimiento práctico hoy está reunido en
            Diccionario Apple, una guía creada para que cualquier persona
            aprenda a usar su iPhone como un experto.
          </p>

          <dl className="mt-8 grid gap-3 sm:grid-cols-3" data-id="element-24" data-mp="2ht1el12a3oyl">
            {STATS.map(stat => <div key={stat.value} className="rounded-2xl border border-white/8 bg-ink-950/70 p-4" data-id="element-25" data-mp="2msnrf9e7336v">
                <dt className="text-xl font-extrabold tracking-tight text-accent-soft" data-id="element-26" data-mp="2rmi967a8p83b">
                  {stat.value}
                </dt>
                <dd className="mt-1 text-xs leading-relaxed text-white/55" data-id="element-27" data-mp="1z4miw0h0nmrg">
                  {stat.label}
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </Section>;
}